import {inject} from 'vue'

const states = {
  0: {
    active: {name: 'active.splash'},
    passive: {name: 'passive.splash'}
  },

  1: {
    active: {name: 'active.alive'},
    passive: {name: 'passive.alive'}
  },

  2: {
    active: {name: 'active.alive'},
    passive: {name: 'passive.alive'}
  },

  3: {
    active: {name: 'active.silence'},
    passive: {name: 'passive.silence'}
  },

  4: {
    active: {name: 'active.intro'},
    passive: {name: 'passive.intro'}
  },

  5: {
    active: {name: 'active.training-intro'},
    passive: {name: 'passive.training-intro'}
  },

  6: {
    active: {name: 'active.training', params: {locationId: 1, step: 1}},
    passive: {name: 'passive.training', params: {locationId: 1, step: 1}}
  },

  7: {
    active: {name: 'active.training', params: {locationId: 1, step: 2}},
    passive: {name: 'passive.training', params: {locationId: 1, step: 2}}
  },

  8: {
    active: {name: 'active.training', params: {locationId: 1, step: 3}},
    passive: {name: 'passive.training', params: {locationId: 1, step: 3}}
  },

  9: {
    active: {name: 'active.training', params: {locationId: 1, step: 4}},
    passive: {name: 'passive.training', params: {locationId: 1, step: 4}}
  },
  10: {
    active: {name: 'active.training', params: {locationId: 1, step: 5}},
    passive: {name: 'passive.training', params: {locationId: 1, step: 5}}
  },

  11: {
    active: {name: 'active.training', params: {locationId: 1, step: 6}},
    passive: {name: 'passive.training', params: {locationId: 1, step: 6}}
  },

  12: {
    active: {name: 'active.science-intro'},
    passive: {name: 'passive.science-intro'}
  },

  13: {
    active: {name: 'active.listen-intro'},
    passive: {name: 'passive.listen-intro'}
  },

  14: {
    active: {name: 'listen-selection'},
    passive: {name: 'passive.listen'}
  },

  15: {
    active: {name: 'active.listen-again'},
    passive: {name: 'passive.listen-again'}
  },

  16: {
    active: {name: 'active.outro'},
    passive: {name: 'passive.outro'}
  },

  17: {
    active: {name: 'active.share'},
    passive: {name: 'passive.share'}
  }
}

let currentState = 0

export function useNavigable() {
  const bus = inject('bus')

  const nextState = () => {
    bus.publish({
      event: 'NEXT_STATE'
    })
  }

  const previousState = () => {
    bus.publish({
      event: 'PREVIOUS_STATE'
    })
  }

  const resetState = () => {
    bus.publish({
      event: 'CHANGE_STATE',
      data: 0
    })
  }

  const goToState = (id) => {
    bus.publish({
      event: 'CHANGE_STATE',
      data: id
    })
  }

  const getNextStateId = () => {
    const ids = Object.keys(states)
    const last = currentState >= ids[ids.length - 1]

    return last ? 0 : currentState + 1
  }

  const getPreviousStateId = () => {
    return Math.max(0, currentState - 1)
  }

  const changeState = (router, mode, state) => {
    currentState = state
    const next = states[currentState][mode]
    router.push(next)
  }

  return {
    resetState,
    getNextStateId,
    getPreviousStateId,
    previousState,
    nextState,
    changeState,
    goToState
  }
}
